import { render, staticRenderFns } from "./SearchIndex.vue?vue&type=template&id=658dc62b&scoped=true&"
import script from "./SearchIndex.vue?vue&type=script&lang=js&"
export * from "./SearchIndex.vue?vue&type=script&lang=js&"
import style0 from "./SearchIndex.vue?vue&type=style&index=0&id=658dc62b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658dc62b",
  null
  
)

export default component.exports